import axios from "axios";
import { toast } from "react-toastify";
import config from "../../config";
import CryptoJS from "crypto-js";

export const mergeClass = (...classes) => {
  return classes.join(" ");
};

export const getFilteredObjectRemove = (object, keys) => {
  let filteredObject = { ...object };
  keys.forEach((key) => {
    delete filteredObject[key];
  });
  return filteredObject;
};

export const getObjectDepth = (object) => {
  let level = 1;
  for (let key in object) {
    if (!object.hasOwnProperty(key) || typeof object[key] !== "object") {
      continue;
    }
    level += getObjectDepth(object[key]);
  }
  return level;
};

export function getLastSegment(url) {
  // Remove trailing slashes if there are any
  url = url.replace(/\/+$/, "");

  // Get the last segment after the last /
  var segments = url.split("/");
  return segments[segments.length - 1];
}

export const unWantedKeys = [
  "_id",
  "__v",
  "updatedAt",
  "createdAt",
  "__comment",
  "_comment",
  "updatedAt",
  "status",
];

export const uploadToPresignedUrl = async (
  presignedUrl = "",
  selectedFile = null,
  setUploadProgress = () => {}
) => {
  try {
    return await axios.put(presignedUrl, selectedFile, {
      headers: {
        "Content-Type": "video",
      },

      onUploadProgress: (data) => {
        const progress = Math.round((100 * data.loaded) / data.total);

        setUploadProgress((prev) => (prev >= progress ? prev : progress));
      },
    });
  } catch (error) {
    return null;
  }
};

export const getNestedObject = (obj = {}, nestedKey = "") => {
  const keys = nestedKey.split(".");
  const value = keys.reduce((acc, currKey) => acc && acc[currKey], obj);
  return value;
};

export const getFormattedPrice = (price, currency = "$") => {
  return `${currency}${parseFloat(price).toFixed(2)}`;
};

export const uploadImages = async (images, token) => {
  // if (!images.length) return null;
  // const formData = new FormData();
  // images.forEach((image) => {
  //   formData.append(getMediaType(image), image);
  // });

  // const res = await Post(
  //   BaseURL("media/upload", "media"),
  //   formData,
  //   apiHeader(token, true)
  // );

  // if (res) {
  //   return res.data?.data;
  // }

  return null;
};

export const uploadImagesHelper = async ({
  images,
  setIsLoading,
  setImages,
  token,
}) => {
  if (images.length === 0) return;

  setIsLoading(true);
  uploadImages(images, token)
    .then((res) => {
      if (res) {
        setImages(res);
      }
      setIsLoading(false);
    })
    .finally(() => {
      setIsLoading(false);
    });
};
export const returnKeyEmptyAsPerType = (item) => {
  if (typeof item === "object") {
    if (Array.isArray(item)) {
      return [];
    } else {
      return returnFillObjectToEmptyWithSameKey(item);
    }
  } else if (typeof item === "string") {
    return "";
  }
};

export const capitalizeFirstLetter = (l) => {
  if (typeof l !== "string" || !l) {
    return "";
  }
  return l.charAt(0).toUpperCase() + l.slice(1);
};

export function htmlToText(html) {
  if (!html || typeof html !== "string") return "";
  if (typeof document === "undefined") {
    return html
      .replace(/<div[^>]*class="[^"]*scalisi-pdf-attachment[^"]*"[^>]*>[\s\S]*?<\/div>/gi, "")
      .replace(/<div[^>]*data-pdf-[^>]*>[\s\S]*?<\/div>/gi, "")
      .replace(/<iframe[\s\S]*?<\/iframe>/gi, "")
      .replace(/<a[^>]*href=["'][^"']*\.pdf[^"']*["'][^>]*>[\s\S]*?<\/a>/gi, "")
      .replace(/<a[^>]*href=["'][^"']*\/pdf\/[^"']*["'][^>]*>[\s\S]*?<\/a>/gi, "")
      .replace(/<a[^>]*href=["'][^"']*cloudinary[^"']*["'][^>]*>[\s\S]*?<\/a>/gi, "")
      .replace(/<[^>]+>/g, " ")
      .replace(/📄\s*[\w\-\.]+\.pdf/gi, "")
      .replace(/📄\s*[^\n\r]+/gi, "")
      .replace(/\b[\w\-\.]+\.pdf\b/gi, "")
      .replace(/Open PDF in full screen/gi, "")
      .replace(/View \/? Download PDF/gi, "")
      .replace(/Download PDF/gi, "")
      .replace(/View PDF/gi, "")
      .replace(/\s+/g, " ")
      .trim();
  }
  try {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;
    tempDiv
      .querySelectorAll(
        ".scalisi-pdf-attachment, [data-pdf-id], [data-pdf-url], iframe, script, style, a[href*='.pdf'], a[href*='.PDF'], a[href*='/pdf/'], a[href*='cloudinary']"
      )
      .forEach((el) => el.remove());
    let text = tempDiv.textContent || tempDiv.innerText || "";
    text = text
      .replace(/📄\s*[\w\-\.]+\.pdf/gi, "")
      .replace(/📄\s*[^\n\r]+/gi, "")
      .replace(/\b[\w\-\.]+\.pdf\b/gi, "")
      .replace(/Open PDF in full screen/gi, "")
      .replace(/View \/? Download PDF/gi, "")
      .replace(/Download PDF/gi, "")
      .replace(/View PDF/gi, "")
      .replace(/\s+/g, " ")
      .trim();
    return text;
  } catch (e) {
    return html
      .replace(/<[^>]+>/g, " ")
      .replace(/\b[\w\-\.]+\.pdf\b/gi, "")
      .replace(/\s+/g, " ")
      .trim();
  }
}

export const returnFillObjectToEmptyWithSameKey = (object) => {
  let newObject = {};
  Object.keys(object).forEach((key) => {
    if (typeof object[key] === "object") {
      newObject[key] = returnFillObjectToEmptyWithSameKey(object[key]);
    } else if (typeof object[key] === "string") {
      newObject[key] = "";
    }
  });
  return newObject;
};

export const postVideoToS3 = async ({ video, url, setVideoProgress }) => {
  await axios
    .put(url, video, {
      headers: {
        "Content-Type": video.type,
      },
      onUploadProgress: (data) => {
        setVideoProgress(Math.round((100 * data.loaded) / data.total));
      },
    })
    .then(() => {
      // toast.success("Video updated successfully.");
      return true;
    })
    .catch(async (e) => {
      toast.warn("Something went wrong. Please try again later.");
      return false;
    })
    .finally(() => {
      setVideoProgress(0);
    });
};

export const formattedKey = (key) => {
  return key
    ?.replace(/([A-Z])/g, " $1")
    .replace(/^./, (str) => str?.toUpperCase());
};

// * URL FUNCTIONS //////////////////////////////////////////////////////////////////!SECTION

export const baseURL = (link) => `${config?.apiBaseUrl}/api/v1/${link}`;
export const mediaUrl = (url) => {
  if (!url) return "";
  let fullUrl = url.startsWith("http")
    ? url
    : url.startsWith("/")
    ? `${config?.apiBaseUrl || ""}${url}`
    : `${config.mediaUrl}/${url}`;

  // Remove fl_attachment if present so browser opens inline preview in new tab
  if (fullUrl.includes("fl_attachment/")) {
    fullUrl = fullUrl.replace("fl_attachment/", "");
  }
  return fullUrl;
};

export const imageUrl = (url) => {
  if (!url) return "";

  if (url.startsWith("/assets")) return url;

  if (url.startsWith("/")) return `${config?.apiBaseUrl || ""}${url}`;

  const result = url.indexOf("http");

  let imageRenderUrl = result === -1 ? `${config.mediaUrl}/${url}` : url;

  // Remove fl_attachment if present so browser opens inline preview in new tab
  if (imageRenderUrl.includes("fl_attachment/")) {
    imageRenderUrl = imageRenderUrl.replace("fl_attachment/", "");
  }

  return imageRenderUrl;
};

// * URL FUNCTIONS //////////////////////////////////////////////////////////////////!SECTION
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!    api header        !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!

export const apiHeader = (token, isFormData) => {
  if (token && !isFormData) {
    return {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };
  }
  if (token && isFormData) {
    return {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
    };
  }
  if (!token && !isFormData) {
    return {
      headers: {
        "Content-Type": "application/json",
      },
    };
  }

  if (!token && isFormData) {
    return {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    };
  }
};

// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!    api header        !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!

// form data

export const CreateFormData = (data) => {
  const formData = new FormData();
  for (let key in data) {
    if (data[key] === null || data[key] === undefined) {
      continue;
    }
    if (Array.isArray(data[key])) {
      for (let d in data[key]) {
        if (typeof data[key][d] == "string") {
          formData.append(key, data[key][d]);
        } else if (
          data[key][d] instanceof File ||
          data[key][d] instanceof Date
        ) {
          formData.append(key, data[key][d]);
        } else if (data[key][d] !== null && data[key][d] !== undefined) {
          formData.append(key, JSON.stringify(data[key][d]));
        }
      }
    } else if (typeof data[key] == "object") {
      if (data[key] instanceof File) {
        formData.append(key, data[key]);
      } else {
        formData.append(key, JSON.stringify(data[key]));
      }
    } else {
      formData.append(key, data[key]);
    }
  }
  return formData;
};

// ******************************** ENCRYPTION FUNCTIONS **********************************!SECTION

export const handleEncrypt = (message) => {
  const encrypted = CryptoJS.AES.encrypt(
    message,
    config.encryptionSecretKey
  ).toString();

  return encrypted;
};

export const handleDecrypt = (encryptedMessage) => {
  if (!encryptedMessage || typeof encryptedMessage !== "string") return "";

  // If already a plain JWT (starts with eyJ), return it directly
  if (encryptedMessage.startsWith("eyJ")) {
    return encryptedMessage;
  }

  try {
    const bytes = CryptoJS.AES.decrypt(
      encryptedMessage,
      config.encryptionSecretKey || "9f8c2a7b4e6d1f3a8c5b2d9e7f1a6c3b"
    );
    const decrypted = bytes.toString(CryptoJS.enc.Utf8);
    return decrypted || (encryptedMessage.startsWith("eyJ") ? encryptedMessage : "");
  } catch (error) {
    // If decryption fails (e.g. malformed or already plain text), return fallback or empty
    return encryptedMessage.startsWith("eyJ") ? encryptedMessage : "";
  }
};
